import MiniCADAPI from "./MiniCADAPI";

/**
 * Default object for user agreement
 * @type {{userId: null, agreementTimestamp: Date}}
 */
const agreementPayload = {
    userId: null,
    agreementTimestamp: new Date(),
};

/**
 *  Saves User Agreement log
 * @param agreementPayload
 * @param token
 * @returns {Promise<*>}
 */
export const saveUserAgreementLog = async ( agreementPayload = agreementPayload, token ) => {
    return await MiniCADAPI.logAgreementLogRecord(agreementPayload, token);
};

/**
 * Obtains GEO Data
 * @param userData
 * @param token
 * @returns {Promise<*>}
 */
export const getUserGeolocationLog = async ( userData = agreementPayload, token ) => {
    return await MiniCADAPI.getGeolocation();
};



// WEBPACK FOOTER //
// ./src/lib/agreement-log.js